import { color } from "metabase/ui/colors";
import type { GroupId, User } from "metabase-types/api";

export const userToColor = (user: User) => {
  return user.is_superuser ? color("accent2") : color("core-brand");
};

const groupColorPalette = [
  color("feedback-negative"),
  color("accent2"),
  color("core-brand"),
  color("accent4"),
  color("accent1"),
];

export const groupIdToColor = (groupId: GroupId) => {
  return groupColorPalette[groupId % groupColorPalette.length];
};
